module.exports = {
      id: "longform-usage",
      viewBox: "0 0 12.6 15.258",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#longform",
      toString: function () {
        return this.url;
      }
    }